import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

import { environment } from '../../environments/environment';

@Injectable()
export class TenantService {
  flags = environment.flags;

  private readonly vUrl = '/v2';
  private readonly resourceUrl = '/tenants';

  constructor(private apiService: ApiService) {}

  create(tenant) {
    return this.apiService.post(`${this.vUrl}${this.resourceUrl}/`, tenant);
  }

  getAll() {
    return this.apiService.get(`${this.vUrl}${this.resourceUrl}/`);
  }

  getOne(tenantId) {
    return this.apiService.get(`${this.vUrl}${this.resourceUrl}/${tenantId}`);
  }

  update(tenant) {
    return this.apiService.put(
      `${this.vUrl}${this.resourceUrl}/${tenant.id}`,
      tenant
    );
  }

  delete(tenant, password) {
    return this.apiService.delete(
      `${this.vUrl}${this.resourceUrl}/${tenant.id}`,
      { password }
    );
  }

  createProfile(profile, tenantId) {
    return this.apiService.post(
      `${this.vUrl}${this.resourceUrl}/${tenantId}/profiles`,
      {
        configJson: profile.configJson,
      }
    );
  }

  getProfiles(tenantId) {
    return this.apiService.get(`${this.resourceUrl}/${tenantId}/profiles`);
  }

  deleteZiaOrganization(tenantId: string, zsOrgId: string) {
    return this.apiService.delete(
      `${this.vUrl}/${this.resourceUrl}/${tenantId}/zsOrganization/${zsOrgId}`
    );
  }

  // TODO: add route to V2
  deleteZpaCustomer(tenantId: string, zpaCustId: string) {
    return this.apiService.delete(
      `${this.resourceUrl}/${tenantId}/zpaCustomers/${zpaCustId}`
    );
  }

  getZsOrg(tenantId) {
    return this.apiService.get(
      `${this.resourceUrl}/${tenantId}/zsOrganization`
    );
  }

  getZpaCustomers(tenantId) {
    return this.apiService.get(`/zpaCustomers?tenantId=${tenantId}`);
  }

  createZsOrgs(tenantId, zsOrgs) {
    return this.apiService.post(
      `${this.vUrl}${this.resourceUrl}/${tenantId}/zsOrganization`,
      zsOrgs
    );
  }

  getAllRegions() {
    return this.apiService.get('/regions');
  }

  getRegions(tenantId: string) {
    return this.apiService.get(`${this.resourceUrl}/${tenantId}/regions`);
  }

  getThemes(tenantId: string) {
    return this.apiService.get(`${this.resourceUrl}/${tenantId}/themes`);
  }

  getTheme(tenantId: string, themeId: string) {
    return this.apiService.get(
      `${this.resourceUrl}/${tenantId}/themes/${themeId}`
    );
  }

  createTheme(tenantId: string, theme) {
    return this.apiService.post(
      `${this.resourceUrl}/${tenantId}/themes`,
      theme
    );
  }

  updateTheme(tenantId: string, themeId: string, theme) {
    return this.apiService.put(
      `${this.resourceUrl}/${tenantId}/themes/${themeId}`,
      theme
    );
  }

  deleteTheme(tenantId: string, themeId: string) {
    return this.apiService.delete(
      `${this.resourceUrl}/${tenantId}/themes/${themeId}`
    );
  }

  getCerts(tenantId: string) {
    return this.apiService.get(`${this.resourceUrl}/${tenantId}/certificates`);
  }

  getCert(tenantId: string, certId: string) {
    return this.apiService.get(
      `${this.resourceUrl}/${tenantId}/certificates/${certId}`
    );
  }

  createCert(tenantId: string, cert) {
    return this.apiService.post(
      `${this.resourceUrl}/${tenantId}/certificates`,
      cert
    );
  }

  updateCert(tenantId: string, certId: string, cert) {
    return this.apiService.put(
      `${this.resourceUrl}/${tenantId}/certificates/${certId}`,
      cert
    );
  }

  deleteCert(tenantId: string, certId: string) {
    return this.apiService.delete(
      `${this.resourceUrl}/${tenantId}/certificates/${certId}`
    );
  }

  getLicenses(tenantId: string) {
    return this.apiService.get(`${this.resourceUrl}/${tenantId}/licenses`);
  }

  updateLicense(tenantId: string, license) {
    const date1 = license.startDate.split('/');
    const date2 = license.endDate.split('/');

    const licensePayload = {
      startDate: new Date(
        Date.UTC(date1[2], date1[0] - 1, date1[1], 0, 0, 0)
      ).toISOString(),
      endDate: new Date(
        Date.UTC(date2[2], date2[0] - 1, date2[1], 0, 0, 0)
      ).toISOString(),
      status: license.status,
      units: license.units,
    };

    return this.apiService.put(
      `${this.resourceUrl}/${tenantId}/licenses/${license.id}`,
      licensePayload
    );
  }
}
